import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import numbersThreeUtils from './utils/numbersThree.utils.js'

export default class NumbersThreeLevelComponent extends BaseLevel {
    onEnter = () => {
        const { value_1, value_2, value_3, answer_required } = this.state.quantities
        const { operation_1, operation_2 } = this.props.level.settings
        let result = 0
        if (answer_required === 'value_1') {
            result = value_1
        } else if (answer_required === 'value_2') {
            result = value_2
        } else if (answer_required === 'value_3') {
            result = value_3
        } else {
            result = operation_1 === 'addition' ? +value_1 + +value_2 : value_1 - value_2
            result =  operation_2 === 'addition' ? +result + +value_3 : result - value_3
        }
        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const operation = this.state.operation
        const settings = {...level.settings, operation}
        const quantities = this.state.quantities
        
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const answerRequired = settings.answer_required || 'answer'
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answer} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && numbersThreeUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, true)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/numbersThree.levels.js